<template>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 tile-for-who">
    <div class="x_panel">
      <div class="x_title">
        <h2>For who?</h2>
        <ul class="nav navbar-right panel_toolbox hidden">
          <li>
            <button class="btn btn-default po-tile-edit-button">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button class="btn btn-success hidden po-tile-confirm-button">
              <i class="fa fa-check"></i> Confirm
            </button>
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>
      <div class="x_content">
        <el-row>
          <el-autocomplete
            v-model="forWhoQuery"
            :fetch-suggestions="forWhoQuerySearch"
            placeholder="Search for saved destinations..."
            @select="handleSelect">
          </el-autocomplete>
        </el-row>
        <br>
        <div class="text-center">
          <el-button
            type="success"
            icon="plus"
            @click="addNewForWho = true">Add new</el-button>
        </div>

      </div>
    </div>
    <el-dialog
      title="Add new"
      :visible.sync="addNewForWho">
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="addNewForWho = false">Cancel</el-button>
        <el-button
          type="success"
          @click="addNewForWho = false">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addNewForWho: false,
      timeout: null,
      forWhoQuery: '',
      forWhoList: [
        { value: 'vue' },
        { value: 'element' },
        { value: 'cooking' },
        { value: 'mint-ui' },
        { value: 'vuex' },
        { value: 'vue-router' },
      ],
    };
  },
  methods: {
    forWhoQuerySearch(queryString, cb) {
      const { forWhoList } = this;
      const results = queryString ? forWhoList.filter(this.createFilter(queryString)) : forWhoList;
      // call callback function to return suggestions
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createFilter(queryString) {
      return link => link.value.indexOf(queryString.toLowerCase()) === 0;
    },
    handleSelect(item) {
      return item;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/PoForWho.vue